export function percentDifference(
  value: null | number | undefined,
  average: null | number | undefined,
): null | number {
  if (value === null || value === undefined || !average) return null;

  return Math.round(((value - average) / average) * 100);
}
